.addItemModal {
  > .content {
    max-width: 100%;
    overflow: visible;

    @media (min-width: 769px) {
      width: auto;
      max-width: 32rem;
    }

    @media (min-width: 1025px) {
      max-width: 53.25rem;
    }
  }

  .item {
    width: 100%;
    margin: 0.5rem 0 0;

    @media (min-width: 1025px) {
      display: flex;
    }

    .image,
    .name,
    .price {
      margin: 0 0 1rem;

      @media (min-width: 400px) {
        margin: 0 0 1.1875rem;
      }
    }

    .image {
      position: relative;
      width: 100%;
      height: 22rem;
      border-radius: 0.75rem;
      overflow: hidden;

      @media (min-width: 1025px) {
        width: 25rem;
        height: 25rem;
        margin: 0 1.5rem 0 0;
      }

      label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        border: 0.0625rem solid var(--neutral-200);
        border-radius: 2rem;
        overflow: hidden;
        cursor: pointer;
        background-color: var(--neutral);

        img {
          max-width: 100%;
          max-height: 100%;
        }

        svg {
          width: 3rem;
          height: 3rem;
          margin-bottom: 0.625rem;
          color: var(--neutral-500);

          @media (min-width: 400px) {
            margin-bottom: 0.75rem;
          }
        }
      }

      input {
        opacity: 0;
        position: absolute;
        width: 0.1px;
        height: 0.1px;
      }

      .paste {
        position: absolute;
        right: 0.75rem;
        bottom: 0.75rem;
        width: 2.5rem;
        height: 2.5rem;

        @media (min-width: 400px) {
          width: 2.875rem;
          height: 2.875rem;
        }

        svg {
          width: 1.375rem;
          height: 1.375rem;

          @media (min-width: 400px) {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }

    .details {
      display: flex;
      flex: 1;
      flex-direction: column;

      .name {
      }

      .price {
        display: flex;
        align-items: flex-end;

        .priceValue {
          max-width: 6rem;
          margin: 0 0.25rem 0 0;
        }

        .priceCurrency {
          position: relative;
          height: 2.875rem;
          margin: 0 0 0 0.0625rem;

          @media (min-width: 769px) {
            margin-left: 0.25rem;
          }
        }
      }

      .wishlist {
        position: relative;

        .wishlistText {
          display: flex;
          flex: 1;
          flex-direction: column;
          align-items: flex-start;
          padding: 0.125rem 0.875rem 0.125rem 0;
          row-gap: 0.125rem;

          @media (min-width: 769px) {
            padding: 0 0.875rem 0 0;
            row-gap: 0.0625rem;
          }
        }
      }

      .notifications {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0 0;
        padding: 0.8125rem 0.9375rem 0.8125rem;
        border: 0.0625rem solid var(--neutral-200);
        border-radius: 0.75rem;
        cursor: pointer;
        background-color: var(--neutral-50);
        gap: 1.375rem;

        .notificationsText {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .notificationsDescription {
          opacity: 0.85;
        }
      }
    }
  }
}
